// NOTE: 360 deg = 2*PI rad
// i.e. 1 deg = PI / 180 rad
//      1 rad = 180 / PI deg
// TODO: Move this to geometry utils in the future
export const DEG_RADS = Math.PI / 180;

export function polarToCartesian(
  angle,
  dist,
  { degs = false, degsOffset = 0, centerX = 0, centerY = 0 } = {}
) {
  const angleToUse = degs ? (angle - degsOffset) * DEG_RADS : angle;

  const rawX = dist * Math.cos(angleToUse);
  const rawY = dist * Math.sin(angleToUse);
  return {
    x: centerX + rawX,
    y: centerY + rawY,
  };
}

export function cartesianToPolar(x, y, normalise = false) {
  const xToUse = normalise ? Math.abs(x) : x;
  const yToUse = normalise ? Math.abs(y) : y;
  const rads = Math.atan2(yToUse, xToUse);
  const degs = rads / DEG_RADS;
  // eslint-disable-next-line no-restricted-properties
  const radius = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  return { rads, degs, radius };
}
